import { create } from "zustand";
import { persist } from "zustand/middleware";

const useStore = create(
  persist(
    (set) => ({
      // Sidebar
      sideBarOpen: true,
      setSideBarOpen: (sideBarOpen) => set(() => ({ sideBarOpen })),

      // Organisation (kept for backward compat — financial filtering)
      organisation: null,
      setOrganisation: (organisation) => set(() => ({ organisation })),
    }),
    {
      name: "accounting-store",
      partialize: (state) => ({ organisation: state.organisation }),
    }
  )
);

export default useStore;
